// extracted by mini-css-extract-plugin
export default {"h2":"H2_h2__s7TAJ","noMargin":"H2_noMargin__bX3mW","noRightMargin":"H2_noRightMargin__f0KPt"};